import React from "react"
import EmptySurvey from "../../images/empty-surveys.svg"

const EmptyState = () => (
  <div className="quiestionnaries-content-empty">
    <img src={EmptySurvey} />
    <span className="quiestionnaries-content-empty-title">
      No hay cuestionarios para mostrar.
    </span>
    <span>¡Crea un cuestionario para poder empezar a medir el clima</span>
    <span>laboral y liderazgo en tu organización!</span>
  </div>
)

export default EmptyState
